module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 12
// module chunks = 0